import React, { useState } from "react";
import "../../../Styles/Tpregistration.css";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ApiService from "../../../nhrc_apis/ApiService";

const TraingprogramRegistration = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const eventData = state?.event;

  const [formData, setFormData] = useState({
    fullName:        "",
    mobile:          "",
    email:           "",
    locaion:         "",
    occupation:      "",
    nhrcId:          "",
    companyname:     "",
    companylocation: "",
    collegeName:     "",
    yearOfPassout:   "",
    updates:         false,
  });

  const [errors,      setErrors]      = useState({});
  const [touched,     setTouched]     = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  // ─── VALIDATE SINGLE FIELD ────────────────────────────────
  const validateField = (name, value) => {
    let error = "";

    switch (name) {

      case "fullName":
        if (!value || !value.trim()) {
          error = "Full name is required.";
        } else if (value.trim().length < 3) {
          error = "Full name must be at least 3 characters.";
        } else if (!/^[a-zA-Z\s]+$/.test(value.trim())) {
          error = "Full name must contain only letters and spaces.";
        }
        break;

      case "mobile":
        if (!value || !value.trim()) {
          error = "Phone number is required.";
        } else if (!/^[0-9]{10}$/.test(value.trim())) {
          error = "Phone number must be exactly 10 digits.";
        }
        break;

      case "email":
        if (!value || !value.trim()) {
          error = "Email is required.";
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim())) {
          error = "Enter a valid email address (e.g. name@example.com).";
        }
        break;

      case "locaion":
        if (!value || !value.trim()) {
          error = "Location is required.";
        } else if (value.trim().length < 2) {
          error = "Location must be at least 2 characters.";
        }
        break;

      case "occupation":
        if (!value || !value.trim()) {
          error = "This field is required.";
        } else if (!/^[a-zA-Z\s]+$/.test(value.trim())) {
          error = "This field must contain only letters and spaces.";
        }
        break;

      case "nhrcId":
        if (!value || !value.trim()) {
          error = "NHRC ID is required.";
        } else if (value.trim().length < 3) {
          error = "NHRC ID must be at least 3 characters.";
        }
        break;

      case "collegeName":
        if (value && value.trim().length > 0 && value.trim().length < 3) {
          error = "College name must be at least 3 characters.";
        }
        break;

      case "yearOfPassout":
        if (value && value.trim().length > 0) {
          if (!/^[0-9]{4}$/.test(value.trim())) {
            error = "Enter a valid 4-digit year (e.g. 2025).";
          } else if (
            parseInt(value.trim()) < 1980 ||
            parseInt(value.trim()) > 2035
          ) {
            error = "Year must be between 1980 and 2035.";
          }
        }
        break;

      case "companyname":
        if (value && value.trim().length > 0 && value.trim().length < 2) {
          error = "Company name must be at least 2 characters.";
        }
        break;

      case "companylocation":
        if (value && value.trim().length > 0 && value.trim().length < 2) {
          error = "Company location must be at least 2 characters.";
        }
        break;

      default:
        break;
    }

    return error;
  };

  // ─── VALIDATE ALL FIELDS ──────────────────────────────────
  const validateAll = () => {
    const requiredFields = [
      "fullName", "mobile", "email", "locaion",
      "occupation", "nhrcId",
    ];
    const optionalFields = [
      "collegeName", "yearOfPassout", "companyname", "companylocation",
    ];

    const allFields  = [...requiredFields, ...optionalFields];
    const newErrors  = {};
    const newTouched = {};

    allFields.forEach((field) => {
      newTouched[field] = true;
      const error = validateField(field, formData[field]);
      if (error) newErrors[field] = error;
    });

    setTouched(newTouched);
    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  // ─── HANDLE CHANGE ────────────────────────────────────────
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const newValue = type === "checkbox" ? checked : value;

    setFormData({ ...formData, [name]: newValue });

    if (name !== "updates") {
      const error = validateField(name, newValue);
      setErrors((prev)  => ({ ...prev, [name]: error }));
      setTouched((prev) => ({ ...prev, [name]: true  }));
    }
  };

  // ─── HANDLE SUBMIT ────────────────────────────────────────
  const handleSubmit = async (e) => {
    e.preventDefault();

    const isValid = validateAll();

    if (!isValid) {
      toast.error("Please fix all errors before submitting.", { autoClose: 2000 });
      return;
    }

    setIsSubmitting(true);

    console.log("━━━━ EVENT DATA FROM STATE ━━━━");
    console.log(eventData);
    console.log("TRAINING ID :", eventData?.id);

    if (!eventData?.id) {
      toast.error("Training ID is missing. Please go back and try again.");
      setIsSubmitting(false);
      return;
    }

    try {
      const payload = {
        training_id:      Number(eventData.id),
        full_name:        formData.fullName.trim(),
        phone:            formData.mobile.trim(),
        email:            formData.email.trim(),
        location:         formData.locaion.trim(),
        iam_a:            formData.occupation.trim(),
        nhrc_id:          formData.nhrcId.trim(),
        receive_updates:  formData.updates,
        college_name:     formData.collegeName.trim()     || null,
        year_of_passout:  formData.yearOfPassout.trim()   || null,
        company_name:     formData.companyname.trim()     || null,
        company_location: formData.companylocation.trim() || null,
      };

      console.log("━━━━ REGISTRATION PAYLOAD ━━━━");
      console.log(JSON.stringify(payload, null, 2));

      const response = await ApiService.RegistrationAPI.registerForTraining(payload);

      console.log("REGISTRATION FULL RESPONSE :", response);
      console.log("REGISTRATION DATA          :", response?.data);
      console.log("REGISTRATION STATUS        :", response?.status);

      toast.success("Registered Successfully!", { autoClose: 2000 });

      setTimeout(() => {
        navigate("/hrdashboard/TrainingProgram");
      }, 2000);

    } catch (err) {
      console.error("━━━━ REGISTRATION ERROR ━━━━");
      console.error("ERROR OBJECT   :", err);
      console.error("ERROR MESSAGE  :", err?.message);
      console.error("ERROR STATUS   :", err?.response?.status);
      console.error("ERROR DATA     :", err?.response?.data);
      console.error("ERROR DETAIL   :", err?.response?.data?.detail);

      if (!err?.response) {
        toast.error("Network Error: Unable to reach the server. Please check your connection or try again later.");
        setIsSubmitting(false);
        return;
      }

      const detail = err?.response?.data?.detail;

      if (detail === "Already Registered") {
        toast.warning("You have already registered for this training program.", { autoClose: 3000 });
        setTimeout(() => { navigate("/hrdashboard/TrainingProgram"); }, 3000);
        return;
      }

      const message =
        (Array.isArray(detail) ? detail.map((d) => d.msg).join(", ") : detail) ||
        err?.response?.data?.message ||
        err?.response?.data?.error   ||
        "Registration failed. Please try again.";

      toast.error(`${message}`);

    } finally {
      setIsSubmitting(false);
    }
  };

  // ─── RENDER ───────────────────────────────────────────────
  return (
    <>
      <div className="tgpregistration-wrapper mt-0">

        <h2 className="tgpregistration-title">REGISTER FORM</h2>

        {eventData && (
          <div className="tgpregistration-training-info">
            <h3 className="tgpregistration-training-title" style={{ color: "#d8d83fff" }}>
              {eventData.title}
            </h3>
            <p className="tgpregistration-training-schedule">
              {eventData.schedule} | {eventData.title}
            </p>
          </div>
        )}

        <form className="tgpregistration-card" onSubmit={handleSubmit} noValidate>
          <div className="tgpregistration-grid">

            {/* Full Name */}
            <div className="tgpregistration-field">
              <label>Full Name*</label>
              <input
                name="fullName"
                value={formData.fullName}
                onChange={handleChange}
                placeholder="Enter your full name"
                className={errors.fullName ? "input-error" : ""}
              />
              {errors.fullName && <span className="error-text">{errors.fullName}</span>}
            </div>

            {/* Phone Number */}
            <div className="tgpregistration-field">
              <label>Phone Number*</label>
              <input
                name="mobile"
                value={formData.mobile}
                onChange={handleChange}
                placeholder="Enter 10-digit phone number"
                maxLength={10}
                className={errors.mobile ? "input-error" : ""}
              />
              {errors.mobile && <span className="error-text">{errors.mobile}</span>}
            </div>

            {/* Email */}
            <div className="tgpregistration-field">
              <label>Email Id*</label>
              <input
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter your email"
                className={errors.email ? "input-error" : ""}
              />
              {errors.email && <span className="error-text">{errors.email}</span>}
            </div>

            {/* Location */}
            <div className="tgpregistration-field">
              <label>Location*</label>
              <input
                name="locaion"
                value={formData.locaion}
                onChange={handleChange}
                placeholder="Enter your location"
                className={errors.locaion ? "input-error" : ""}
              />
              {errors.locaion && <span className="error-text">{errors.locaion}</span>}
            </div>

            {/* I am a */}
            <div className="tgpregistration-field">
              <label>I am a*</label>
              <input
                name="occupation"
                value={formData.occupation}
                onChange={handleChange}
                placeholder="e.g. Student, Professional"
                className={errors.occupation ? "input-error" : ""}
              />
              {errors.occupation && <span className="error-text">{errors.occupation}</span>}
            </div>

            {/* NHRC ID */}
            <div className="tgpregistration-field">
              <label>NHRC ID*</label>
              <input
                name="nhrcId"
                value={formData.nhrcId}
                onChange={handleChange}
                placeholder="Enter your NHRC ID"
                className={errors.nhrcId ? "input-error" : ""}
              />
              {errors.nhrcId && <span className="error-text">{errors.nhrcId}</span>}
            </div>

            {/* College Name */}
            <div className="tgpregistration-field">
              <label>College Name*</label>
              <input
                name="collegeName"
                value={formData.collegeName}
                onChange={handleChange}
                placeholder="Enter your college name"
                className={errors.collegeName ? "input-error" : ""}
              />
              {errors.collegeName && <span className="error-text">{errors.collegeName}</span>}
            </div>

            {/* Year of Passout */}
            <div className="tgpregistration-field">
              <label>Year of Passout*</label>
              <input
                name="yearOfPassout"
                value={formData.yearOfPassout}
                onChange={handleChange}
                placeholder="e.g. 2020"
                maxLength={4}
                className={errors.yearOfPassout ? "input-error" : ""}
              />
              {errors.yearOfPassout && <span className="error-text">{errors.yearOfPassout}</span>}
            </div>

            {/* Company Name */}
            <div className="tgpregistration-field">
              <label>Company Name*</label>
              <input
                name="companyname"
                value={formData.companyname}
                onChange={handleChange}
                placeholder="Enter your company name"
                className={errors.companyname ? "input-error" : ""}
              />
              {errors.companyname && <span className="error-text">{errors.companyname}</span>}
            </div>

            {/* Company Location */}
            <div className="tgpregistration-field">
              <label>Company Location*</label>
              <input
                name="companylocation"
                value={formData.companylocation}
                onChange={handleChange}
                placeholder="Enter company location"
                className={errors.companylocation ? "input-error" : ""}
              />
              {errors.companylocation && <span className="error-text">{errors.companylocation}</span>}
            </div>

            {/* Checkbox */}
            <div className="tgpregistration-checkbox">
              <input
                type="checkbox"
                name="updates"
                id="updates"
                checked={formData.updates}
                onChange={handleChange}
              />
              <label htmlFor="updates">
                Would you like to receive updates about future events and professional opportunities? *
              </label>
            </div>

          </div>

          <button
            className="tgpregistration-submit"
            type="submit"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Submitting..." : "SUBMIT"}
          </button>

        </form>
      </div>

      <ToastContainer position="top-center" />
    </>
  );
};

export default TraingprogramRegistration;